import { render, staticRenderFns } from "./FunFactsArea.vue?vue&type=template&id=efbf2964&scoped=true&"
import script from "./FunFactsArea.vue?vue&type=script&lang=js&"
export * from "./FunFactsArea.vue?vue&type=script&lang=js&"
import style0 from "./FunFactsArea.vue?vue&type=style&index=0&id=efbf2964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbf2964",
  null
  
)

export default component.exports